import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useSetNewPasswordApi } from '../../Hooks/useSetNewPasswordApi';

export const useSetNewPassword = () => {
  const { showMessage } = useSnackbar();
  const { createNewPassword } = useSetNewPasswordApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createNewPassword(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Password successfully reset',
        'success'
      );
    },
    onError: (error: any) => {
      showMessage(error.response?.data?.message || 'Failed to login', 'error');
    },
  });
};
